<template>
    <div 
        :class="['row', ...getClassList(element.classList), {'d-none': element.elementVisibility && element.elementVisibility === 'none'}]" 
        :key="element.elementGetParamMap + '_' + index" 
        :ref="element.elementGetParamMap" 
        :id="element.elementGetParamMap"
        >
        <div v-if="element.beforeText" style="padding:20px 20px 0 20px"> <i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i> {{ element.beforeText }}</div>
        <label v-if="typeof element.label !== 'undefined' && element.label !== ''" class="col-form-label col-md-12">
            <span>{{ element.label }}</span>
            <span v-if="element.floor"> (только целые числа)</span>
            <span v-if="element.required === true" class="required"> *обязательно</span>
        </label>
        <div :class="['form-group','col-md-12',{'required': element.required}]">
            <slot></slot>
        </div>
        <div v-if="element.afterText"> <i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i> {{ element.afterText }}</div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      element: Object,
      index: Number
    },
    methods: {
        getClassList(classListString) {
            if (classListString) {
                return classListString.split(' ').filter(className => className.trim().length > 0);
            }
            return [];
        }
    }
  };
  </script>
